import ColorStyles from '@components/ColorStyles';
import BrPopupDialog from './BrPopupDialog';

BrPopupDialog.ColorStyles = ColorStyles;
export default BrPopupDialog;
